import {
  InMemoryHeader,
  InMemoryString,
  InMemoryBoolean
} from "pbas-vue-components";
import { translate } from '../trans'
import store from '@/store'

const InMemoryContactsHeaders = [
  new InMemoryHeader({
    title: "Id",
    type: new InMemoryString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
    version: 1
  }),
  new InMemoryHeader({
    title: "globals.name",
    type: new InMemoryString("Name"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "headers.contacts.email",
    type: new InMemoryString("Email"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "globals.status",
    type: new InMemoryString("Status/Name", {
      getString: item => {
        if (!item) return "";
        const lang = store.getters['common/language']
        return translate(item.Status, lang.language);
      }
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "Status Id",
    type: new InMemoryString("Status/Id"),
    visible: false,
    allowVisibilityChange: false
  }),
  new InMemoryHeader({
    title: "StatusId",
    type: new InMemoryString("StatusId"),
    visible: false,
    allowVisibilityChange: false
  }),
  new InMemoryHeader({
    title: "components.plancreationwizard.primary",
    type: new InMemoryBoolean("IsPrincipal"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "InHouse",
    type: new InMemoryBoolean("IsInHouse"),
    visible: false,
    allowVisibilityChange: false
  })
];
export default InMemoryContactsHeaders;